import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AuthState {
  user: IUser | null;
  accessToken: string | null;
  isUserLoaded: boolean;
  // 2FA challenge state
  challengeSession: string | null;
  tokenObtainedAt: number | null;
}

const token = localStorage.getItem("accessToken");

const initialState: AuthState = {
  user: null,
  accessToken: token,
  isUserLoaded: false,
  challengeSession: null,
  tokenObtainedAt: null,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser: (state, { payload }: PayloadAction<AuthState["user"]>) => {
      state.user = payload;
      state.isUserLoaded = true;
    },
    setUserToken: (
      state,
      { payload: accessToken }: PayloadAction<AuthState["accessToken"]>
    ) => {
      state.accessToken = accessToken;
      state.tokenObtainedAt = Date.now();
    },
    setChallenge: (
      state,
      {
        payload,
      }: PayloadAction<{ challengeSession: string }>
    ) => {
      state.challengeSession = payload.challengeSession;
    },
    clearChallenge: (state) => {
      state.challengeSession = null;
    },
    logout: (state) => {
      state.user = null;
      state.accessToken = null;
      state.challengeSession = null;
      state.tokenObtainedAt = null;
    },
  },
});

export const { setUser, setUserToken, setChallenge, clearChallenge, logout } =
  authSlice.actions;
